import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsCheckLg } from 'react-icons/bs';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';

import { PSButton } from '@/components/ui/button';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { useAppDispatch, useAppSelector } from '../../../app/hook';
import { useGetClientPlansQuery, useRedirectToPayModMutation } from '../../../app/services/billing-rtk.service';
import { MultiLanguageUrl } from '../../../constants/multiLanguage.constant';
import { Plans } from '../../../constants/plans.constant';
import { selectIsUserNew } from '../../../features/auth/auth.slice';
import { selectChosenPlan, setChosenPlan } from '../../../features/dashboard.slice';
import IPlan from '../../../interfaces/models/plan.interface';

const BillingCheckInPage = () => {
  const { i18n, t } = useTranslation();
  const [isMonthly, setIsMonthly] = useState(false);
  const isUserNew = useAppSelector(selectIsUserNew);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [useRedirectToPayMod, useRedirectToPayModStatus] = useRedirectToPayModMutation();

  const selectChoosePlan = useAppSelector(selectChosenPlan);

  const [searchParams, setSearchParams] = useSearchParams();

  let plan: IPlan | null = null;

  const queryPlan = searchParams.get('plan');
  const queryisMonthly = searchParams.get('isMonthly');

  if (queryPlan && queryisMonthly) {
    const findPlan = Plans.find(dr => dr.name == queryPlan && dr?.isMonthly == (queryisMonthly == 'true' ? true : false));
    if (findPlan) {
      plan = findPlan;
    } else {
      navigate('../billing-create');
    }
  } else if (selectChoosePlan) {
    const findPlan = selectChoosePlan;
    if (findPlan) {
      plan = findPlan;
    } else {
      navigate('../billing-create');
    }
  } else {
    navigate('../billing-create');
  }

  const redirectToPay = (planName: string) => {
    useRedirectToPayMod({
      plan: planName,
      redirectUrl: `${MultiLanguageUrl[i18n.language] || 'en-US'}/verify-plan`,
    })
      .unwrap()
      .then(res => {
        window.open(res, '_self');
      });
    // .catch((res) => {});
  };

  const changePlan = () => {
    navigate({
      pathname: '../billing-create',
      search: createSearchParams({
        plan: plan?.name as string,
      }).toString(),
    });
    dispatch(setChosenPlan(null));
  };

  const getTotalPrice = (price?: number) => {
    return price ? '$ ' + price.toFixed(2) : '$0';
  };

  return (
    <section className="bg-eightColor tw-h-full tw-min-h-screen">
      <Row className=" md:tw-max-w-[1200px] tw-m-auto">
        <Col>
          <Row className="mt-5">
            <Col className="d-flex flex-column justify-content-center   align-items-center">
              <h1 className="font-poppins fw-bold  text-center">{t('BillingCheckInPage/title')}</h1>
            </Col>
          </Row>
          <Row className="p-lg-5  tw-py-8 tw-px-5 md:tw-px-0">
            <Col className="px-lg-5">
              <Row className="px-lg-5">
                <Col className="border rounded tw-bg-gray-100">
                  <Row className="border-bottom px-4 py-3">
                    <Col className="d-flex justify-content-between align-items-center tw-flex-wrap">
                      <div>
                        <h1 className="font-poppins tw-flex tw-flex-wrap tw-gap-2">
                          {plan?.title != 'PlansConstant/t-02' && <span>{plan?.isMonthly ? t('BillingCheckInPage/t-01') : t('BillingCheckInPage/t-02')}</span>}
                          <span>{t(plan?.title || '')}</span>
                        </h1>
                        <div className="d-flex align-items-center ">
                          <h3 className="font-poppins m-0 me-1">{getTotalPrice(plan?.price)}</h3>
                        </div>
                      </div>
                      <div className="tw-flex tw-gap-3 tw-flex-wrap md:tw-w-auto tw-w-full md:tw-mt-0 tw-mt-9 tw-flex-col-reverse md:tw-flex-row ">
                        <PSButton
                          id="btn-checkin-change-plan"
                          className="md:tw-w-40 tw-w-full  tw-flex tw-justify-center tw-h-11"
                          variant="info"
                          size="sm"
                          onClick={changePlan}
                          title={t('BillingCheckInPage/btn-01')}
                        />
                        <PSButton
                          id="btn-checkin-pay"
                          className="md:tw-w-40 tw-w-full tw-flex tw-justify-center tw-h-11"
                          variant="primary"
                          size="sm"
                          onClick={() => {
                            redirectToPay(plan?.name as string);
                          }}
                          title={t('BillingCheckInPage/btn-02')}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="py-3">
                    <Col>
                      <Row className="px-4 tw-mt-8">
                        <Col lg="12">
                          <span className="px-2 font-sofiaSans tw-text-lg tw-font-bold tw-text-zinc-500">{t('BillingCheckInPage/t-03')}</span>
                        </Col>
                      </Row>
                      <Row className="pe-3  px-4">
                        {plan?.features.map((item, index) => (
                          <Col lg="12" key={index} className="d-flex align-items-center gap-2 p-2 ">
                            <>
                              <span className="px-2 py-1 rounded-circle color-thirdColor">
                                <BsCheckLg />
                              </span>
                              <span className="fs-5 fw-bold">{t(item.name)}</span>
                            </>
                          </Col>
                        ))}
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default WrappedErrorBoundary(BillingCheckInPage);
